import React from "react";
import { Hub } from "aws-amplify/utils";
import { useNotifications } from "features/notifications";

export const useOnAuthHandler = () => {
  const { addNotification } = useNotifications();

  React.useEffect(() => {
    const unsubscribe = Hub.listen("auth", (data) => {
      const { event } = data.payload;

      if (event === "tokenRefresh_failure") {
        addNotification({
          type: "warning",
          header: "Session refresh failed",
          content:
            "Your session could not be refreshed. Please refresh the page to sign in again.",
          dismissible: true,
        });
      }
    });

    return unsubscribe;
    // Registered once: addNotification only closes over the stable dispatch.
  }, []);
};
